module.exports = __webpack_public_path__ + "img/bda81f98ec408994ad01e684934cdd72.png";